/*eslint-disable */
var clearTimeoutState;

import { bus } from '@/main';
import covidPopup from '@/components/public/common/covid-19-popup';
import mainLoginFormPopup from '@/components/authentication/main-login-form-popup/';
import random_img from '@/assets/images/lange_crub.jpg';
import random_img1 from '@/assets/images/random_img/lange_crub_1.jpg';
import random_img2 from '@/assets/images/random_img/lange_crub_2.jpg';
import random_img3 from '@/assets/images/random_img/lange_crub_3.jpg';
import random_img4 from '@/assets/images/random_img/lange_crub_4.jpg';
import random_img5 from '@/assets/images/random_img/lange_crub_5.jpg';
import resendOtpPopup from '@/components/authentication/resend-otp-popup/';

const $ = window.jQuery = require('jquery');
// Multi Color Bg Img Of Section
export default {
  name: 'login-main-page',
  components: {
    'covid-popup': covidPopup,
    'resend-otp': resendOtpPopup,
    'main-login-form-popup' : mainLoginFormPopup
  },
  props: [],
  data() {
    return {
      preloader: true,
      randomImg: '',
      animationImg: '',
      first_slide: true,
      second_slide: false,
      firstTimeVisit: sessionStorage.getItem('firstTimeVisit'),
      isMobile:false,
    }
  },
  computed: {
  },
  mounted() {
    if (localStorage.getItem('token') != null && localStorage.getItem('LoginedUserID') != null) {
      this.$router.push('/');
    }
    this.animationImg = random_img
    bus.$emit('showHeaderbtn', false);
    this.randomImg = random_img
    this.randomImgSlide()
    this.randomImgLoaded()
    setInterval(() => {
      this.randomImgSlide()
    }, 20000);
    setInterval(() => {
      this.randomImgLoaded()
    }, 21500);
  },
  methods: {
    popupCloseEventMethod(){
      this.$router.push('/');
    },
    onResize() {
      this.isMobile = window.innerWidth < 769
    },
    randomImgSlide() {
      setTimeout(() => {
        $(".oncology_well_new").addClass("active")
        $(".oncology_wel_popup").removeClass("active")
        setTimeout(() => {
          $(".oncology_well_new").css('z-index', '10')
          $(".oncology_wel_popup").css('z-index', '11')
          $(".oncology_wel_line_crub").addClass("animation_play")
        }, 1505)
      }, 10000)
      setTimeout(() => {
        $(".oncology_well_new").removeClass("active")
        $(".oncology_wel_popup").addClass("active")
        setTimeout(() => {
          $(".oncology_wel_popup").css('z-index', '10')
          $(".oncology_well_new").css('z-index', '11')
          $(".oncology_wel_line_crub").removeClass("animation_play")
        }, 1500)
      }, 20000)
    },
    randomImgLoaded() {
      setTimeout(() => {
        this.randomImg = random_img1
      }, 3500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 5500)
      setTimeout(() => {
        this.randomImg = random_img2
      }, 7500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 9500)
      setTimeout(() => {
        this.randomImg = random_img3
      }, 11500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 13500)
      setTimeout(() => {
        this.randomImg = random_img4
      }, 15500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 17500)
      setTimeout(() => {
        this.randomImg = random_img5
      }, 19500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 21500)
    },
  },
  beforeCreate: function () {
    document.body.classList.add('login_body');
  },
  beforeRouteLeave: function (to, from, next) {
    document.body.classList.remove('login_body');
    document.body.classList.remove('signup_page_wrp');
    next();
  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
}
